import { Component, OnInit, signal, computed } from '@angular/core';
import { TicketType } from 'src/app/models/ticketTypeModels';

import {  Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { deleteTicketType, loadTicketTypes } from 'src/app/core/store/ticket-types/ticket-types.actions';
import { BaseComponent } from 'src/app/core/abstracts/baseComponent';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Observable, finalize, take } from 'rxjs';

@Component({
    selector: 'app-ticket-types-list',
    templateUrl: './ticket-types-list.component.html',
    styleUrls: ['./ticket-types-list.component.scss'],
    standalone: false
})
export class TicketTypesListComponent  extends BaseComponent implements OnInit {
  ticketTypes: TicketType[];
  loading;
  saving: boolean = false;
  showArchived: boolean = false;
  archiveConfirmation: Observable<boolean> | null = null;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(private store: Store<State>, private router: Router, private alertService: AlertService) {
    super();  
  }

  ngOnInit(): void {
    this.subs.push(
        this.store.select(s => s.ticketTypesState).subscribe(ticketTypesState => {
            if (ticketTypesState){
                this.ticketTypes = (ticketTypesState.ticketTypes || []).filter(t => this.showArchived || !t.archivedDate);
                this.totalRecords.set(this.ticketTypes.length);
            }
            this.loading = ticketTypesState.loading;
            this.saving = ticketTypesState.saving;
        })
    );
    this.reloadList();
  }

  reloadList(): void {
    this.store.dispatch(loadTicketTypes({ includeArchived: this.showArchived }));
  }

  setArchivedStatus(ticketType: TicketType): void {
    if (this.saving || this.archiveConfirmation || !ticketType.canDeleteTypes) return;
    const id = ticketType.id;
    const archived = !ticketType.archivedDate;
    const confirmation = this.alertService.confirm((archived ? 'Archive Ticket Type - ' : 'Unarchive Ticket Type - ') + ticketType.name,
      archived ? 'Archive this ticket type? Its tickets and settings will be retained, and you can restore it using Show archived ticket types.'
        : 'Unarchive this ticket type and make it available again?');
    this.archiveConfirmation = confirmation;
    this.subs.push(confirmation.pipe(take(1), finalize(() => this.archiveConfirmation = null)).subscribe(answer => {
      if (answer && !this.saving) this.store.dispatch(deleteTicketType({ id, archived }));
    }));
  }

  ngOnDestroy(): void {
    if (this.archiveConfirmation) this.alertService.cancelConfirmation(this.archiveConfirmation);
    super.ngOnDestroy();
  }

  getCustomFields(ticketType: TicketType){
    return ticketType.customFields.filter(x => x.deletedDate == null);
  }

  editTicketType(ticketTypeId: number): void {
    this.router.navigate(['/ticket-types/edit', ticketTypeId]);
  }
}
